import { useSelector } from "react-redux";
import { selectState } from "../main.slice";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";

const TableFooter = () => {
  const { buildings } = useSelector(selectState);
  const { selectedBuilding } = useSelector(selectState);
  const { selectedSalesUnit } = useSelector(selectState);

  return (
    <div className="g-grid g-footer">
      <div className="row">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div className="col right">
          <div></div>
          <div className="bg-item bg-item-dark center footer-col-total-square-meters">
            {selectedSalesUnit < 0 &&
              FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalSquareMeters, "kvm")}
          </div>
          <div>
            <div className="bg-item bg-item-dark center footer-double-value">
              {selectedSalesUnit < 0 && (
                <>
                  <span className="bg-text-overflow">
                    {FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalSquareMetersSold, "kv")}
                  </span>
                  <span className="bg-text-overflow">
                    {FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.percentageSquareMetersSold, "%")}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="bg-item bg-item-dark center overflowMinWidth footer-col-total-sold-price">
            <span className="bg-text-overflow">
              {selectedSalesUnit < 0 &&
                FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalSoldBuildingPrice, "e")}
            </span>
          </div>
        </div>
        <div></div>
        <div className="col hrs-footer-div">
          <div className="bg-item bg-item-dark center overflowMinWidth">
            <InfoTooltip tooltip={FormatNumberWithUnitOrNull(
              buildings[selectedBuilding]?.totalReceivableAmount, "e") ?? undefined}
              classesProp="bg-text-overflow" element="span">
              {selectedSalesUnit < 0 &&
                FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalReceivableAmount, "e")}
            </InfoTooltip>
          </div>
        </div>
        <div className="col hrs-footer-div">
          <div className="bg-item bg-item-dark center overflowMinWidth">
            <InfoTooltip classesProp="bg-text-overflow" element="span"
              tooltip={FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalPaidAmount, "e")
                ?? undefined}>
              {selectedSalesUnit < 0 &&
                FormatNumberWithUnitOrNull(buildings[selectedBuilding]?.totalPaidAmount, "e")}
            </InfoTooltip>
          </div>
        </div>
        <div className="col hrs-footer-div">
          <div className="bg-item bg-item-dark center overflowMinWidth">
            <InfoTooltip classesProp="bg-text-overflow" element="span"
              tooltip={FormatNumberWithUnitOrNull(
                buildings[selectedBuilding]?.totalRestForPaymant, "e") ?? undefined}
            >
              {selectedSalesUnit < 0 && FormatNumberWithUnitOrNull(
                buildings[selectedBuilding]?.totalRestForPaymant, "e")}
            </InfoTooltip>
          </div>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <div className="col right">rate za naplatu</div>
        <div className="col">
          <div className="bg-item bg-item-dark center">2.252e</div>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default TableFooter;
